import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { UserAuth } from "../context/AuthContext";

// Hardcoded mosaic names - same as home page
const mosaicNames = [
  // A grades - short
  { name: "DAISY", grade: "A" }, { name: "GLAZE", grade: "A" }, { name: "ROTE", grade: "A" }, { name: "PEEL", grade: "A" },
  { name: "SLASH", grade: "A" }, { name: "YUZO", grade: "A" }, { name: "FEELIX", grade: "A" }, { name: "PRISI", grade: "A" },
  { name: "TWAY", grade: "A" }, { name: "ZIYA", grade: "A" }, { name: "AMIR", grade: "A" }, { name: "FLUKE", grade: "A" },
  // A grades - medium
  { name: "SOLRISE", grade: "A" }, { name: "GENECHO", grade: "A" }, { name: "ORDAPATH", grade: "A" }, { name: "STARRY SKY", grade: "A" },
  { name: "REDDIA", grade: "A" }, { name: "BOULDER", grade: "A" }, { name: "AIRBEAR", grade: "A" }, { name: "JERRELL", grade: "A" },
  { name: "REBREEVA", grade: "A" }, { name: "EARTHY", grade: "A" }, { name: "ARMARA", grade: "A" }, { name: "REKREA", grade: "A" },
  // A grades - long
  { name: "CANDYMACHINE", grade: "A" }, { name: "ETERNAL FEAST", grade: "A" }, { name: "ONE BIG WINDOW", grade: "A" }, { name: "LIKEWORTHY", grade: "A" },
  { name: "COPPERHALL", grade: "A" }, { name: "MEMORY MADE", grade: "A" }, { name: "SIP AND SAVOR", grade: "A" }, { name: "COME ALIVE", grade: "A" },
  // B grades - short
  { name: "PERTY", grade: "B" }, { name: "ENTIFI", grade: "B" }, { name: "GIANNA", grade: "B" }, { name: "DAWNS", grade: "B" },
  { name: "SAVORY", grade: "B" }, { name: "ROSE", grade: "B" }, { name: "BOOK", grade: "B" }, { name: "CAPITAL", grade: "B" },
  { name: "TWANG", grade: "B" }, { name: "PILL", grade: "B" }, { name: "CLEAT", grade: "B" }, { name: "KNOCK", grade: "B" },
  // B grades - medium
  { name: "RESURGENT", grade: "B" }, { name: "PROLIFERATE", grade: "B" }, { name: "WELLSPRING", grade: "B" }, { name: "FOOTHILLS", grade: "B" },
  { name: "SOFT LIGHT", grade: "B" }, { name: "PILL POINT", grade: "B" }, { name: "LITERACY", grade: "B" }, { name: "CREATURE", grade: "B" },
  { name: "TWINKLER", grade: "B" }, { name: "ADJUSTER", grade: "B" }, { name: "EXAMINA", grade: "B" }, { name: "JACENT", grade: "B" },
  // B grades - long
  { name: "ROSE COMPASS", grade: "B" }, { name: "FOR ALWAYS", grade: "B" }, { name: "NEW PROTOCOL", grade: "B" }, { name: "BRIGHTLINE", grade: "B" },
  { name: "GREEN SHOOTS", grade: "B" }, { name: "CONTEMPLATED", grade: "B" }, { name: "GOOD GROUND", grade: "B" }, { name: "BITE BAZAAR", grade: "B" },
  // C grades - short
  { name: "CALLER", grade: "C" }, { name: "SOLTERA", grade: "C" }, { name: "EDEMIC", grade: "C" }, { name: "ZODIAC", grade: "C" },
  { name: "ADACIA", grade: "C" }, { name: "CLARE", grade: "C" }, { name: "CHATTER", grade: "C" }, { name: "GEMMA", grade: "C" },
  { name: "SENA", grade: "C" }, { name: "KUMU", grade: "C" }, { name: "KARMAN", grade: "C" }, { name: "REROUTE", grade: "C" },
  // C grades - medium
  { name: "NOVASTREAM", grade: "C" }, { name: "CROSSWORD", grade: "C" }, { name: "DOUGHNUT", grade: "C" }, { name: "AKROFLOW", grade: "C" },
  { name: "MOUNTAYO", grade: "C" }, { name: "RIGHTON", grade: "C" }, { name: "NETFLOW", grade: "C" }, { name: "WATCH FACE", grade: "C" },
  { name: "CULTURE CLUB", grade: "C" }, { name: "VIBRITE", grade: "C" }, { name: "GRAFTA", grade: "C" }, { name: "GALORE", grade: "C" },
  // C grades - long
  { name: "SPACE STATION", grade: "C" }, { name: "ATOMIC LANE", grade: "C" }, { name: "ALPINE STATE", grade: "C" }, { name: "STREAMLINK", grade: "C" },
  { name: "TWO AND ONE", grade: "C" }, { name: "WATERSPOUT", grade: "C" }, { name: "PAINT THE TOWN", grade: "C" }, { name: "DYNASTREAM", grade: "C" },
  // D grades - short
  { name: "TOLLA", grade: "D" }, { name: "LUMI", grade: "D" }, { name: "TEETH", grade: "D" }, { name: "SPECULAR", grade: "D" },
  { name: "HIFIGURE", grade: "D" }, { name: "PILLOW", grade: "D" }, { name: "MENTAL", grade: "D" }, { name: "LONGSIDE", grade: "D" },
  { name: "AFFOLD", grade: "D" }, { name: "UNITION", grade: "D" }, { name: "SMARA", grade: "D" }, { name: "JAIRO", grade: "D" },
  // D grades - medium
  { name: "ON SITE", grade: "D" }, { name: "BLOOPER", grade: "D" }, { name: "TALKSHOW", grade: "D" }, { name: "VICTORIA", grade: "D" },
  { name: "WHISPER", grade: "D" }, { name: "SPITZE", grade: "D" }, { name: "YOUNG MUSE", grade: "D" }, { name: "LAYER UP", grade: "D" },
  { name: "MOODRAY", grade: "D" }, { name: "BANNER", grade: "D" }, { name: "PRIMAPULSE", grade: "D" }, { name: "DARAI", grade: "D" },
  // D grades - long
  { name: "OUTTA HERE", grade: "D" }, { name: "DROP ZONE", grade: "D" }, { name: "DREAMWIRE", grade: "D" }, { name: "FULL HOUSE", grade: "D" },
  { name: "TIMECAPSULE", grade: "D" }, { name: "BRIGHTBUSH", grade: "D" }, { name: "MASTERFLOW", grade: "D" }, { name: "WATCH TOWER", grade: "D" },
  // F grades - short
  { name: "BREEZY", grade: "F" }, { name: "ESSIUS", grade: "F" }, { name: "WHIFF!", grade: "F" }, { name: "VESPER", grade: "F" },
  { name: "LULURE", grade: "F" }, { name: "TAG TEAM", grade: "F" }, { name: "PILSON", grade: "F" }, { name: "HOODLE", grade: "F" },
  { name: "INEVITABLE", grade: "F" }, { name: "DYNAFLOW", grade: "F" }, { name: "PEEKER", grade: "F" }, { name: "SAPPY", grade: "F" },
  // F grades - medium
  { name: "GLIMMER", grade: "F" }, { name: "EYE-TO-EYE", grade: "F" }, { name: "MINDER", grade: "F" }, { name: "CLEARDAY", grade: "F" },
  { name: "LUMASTREAM", grade: "F" }, { name: "HYPERLINK", grade: "F" }, { name: "STREAKY", grade: "F" }, { name: "MONOWAVE", grade: "F" },
  { name: "METAWELL", grade: "F" }, { name: "NOVASTREAM", grade: "F" }, { name: "AKROFLOW", grade: "F" }, { name: "FOOTHILLS", grade: "F" },
  // F grades - long
  { name: "WIDE WORLD", grade: "F" }, { name: "SUFFIXER", grade: "F" }, { name: "WORD SPLIT", grade: "F" }, { name: "NEW MUSIC", grade: "F" },
  { name: "OBJECT ABS", grade: "F" }, { name: "VOWEL REM", grade: "F" }, { name: "INTERNAL S", grade: "F" }, { name: "ONOMATOP", grade: "F" },
  // Extra fill
  { name: "SUNFLOWER", grade: "A" }, { name: "EXPANDER", grade: "B" }, { name: "KAIKAN", grade: "C" }, { name: "SPACESUIT", grade: "D" },
  { name: "CADDY", grade: "A" }, { name: "TWENTY", grade: "B" }, { name: "COFACTOR", grade: "C" }, { name: "JUBUL", grade: "D" },
  { name: "TREETOPS", grade: "A" }, { name: "HEAVILY", grade: "B" }, { name: "GURNY", grade: "C" }, { name: "COMMANDEER", grade: "D" },
  { name: "CALL", grade: "A" }, { name: "OXYMORONS", grade: "B" }, { name: "EXAMINA", grade: "C" }, { name: "TREADLORD", grade: "D" },
  { name: "POSTLAYER", grade: "A" }, { name: "YIKES", grade: "B" }, { name: "ANAGRAM", grade: "C" }, { name: "COMPOUNDS", grade: "D" },
  { name: "PLACENAME", grade: "A" }, { name: "FIND NOUNS", grade: "B" }, { name: "PURALIZE", grade: "C" }, { name: "SANCTUM", grade: "D" },
  { name: "AETHEREAL", grade: "A" }, { name: "ASSUMING", grade: "B" }, { name: "BEBBLE", grade: "C" }, { name: "LOADCAST", grade: "D" },
  { name: "DARTBOARD", grade: "A" }, { name: "BIG WIDE", grade: "B" }, { name: "CHUCKITS", grade: "C" }, { name: "CLEAT", grade: "D" },
  { name: "CAELA", grade: "A" }, { name: "WEARADAY", grade: "B" }, { name: "REVELATORY", grade: "C" }, { name: "TENDLY", grade: "D" },
  { name: "MANY MIND", grade: "A" }, { name: "CLAY MILL", grade: "B" }, { name: "SALUTATION", grade: "C" }, { name: "AIRBORN", grade: "D" },
  { name: "UPSCALE", grade: "A" }, { name: "CONVEY", grade: "B" }, { name: "ONESHIP", grade: "C" }, { name: "KLEISTER", grade: "D" },
  { name: "MILAGE", grade: "A" }, { name: "FATE", grade: "B" }, { name: "FLARE", grade: "C" }, { name: "AMULETIC", grade: "D" },
  { name: "LIGHTRIFT", grade: "A" }, { name: "BLUFF", grade: "B" }, { name: "BOURNES", grade: "C" }, { name: "SAWHILL", grade: "D" },
].map((n, i) => ({ ...n, uniqueId: `name-${i}` }));

const shuffledNames = [...mosaicNames].sort(() => 0.5 - Math.random());

const gradeColors = {
  A: "text-success",
  B: "text-info",
  C: "text-warning",
  D: "text-error",
  F: "text-error",
};

const Signin = () => {
  const [error, setError] = useState("");
  const { googleSignIn, user } = UserAuth();
  const navigate = useNavigate();

  const handleGoogleSignIn = async e => {
    e.preventDefault();
    try {
      setError("");
      const user = await googleSignIn();
      if (user) {
        navigate("/");
      }
    } catch (error) {
      console.error("Sign in error:", error);
      if (error.message.includes("not authorized")) {
        setError("You are not authorized to access this application.");
      } else if (error.message === "Sign-in cancelled") {
        setError("Sign-in was cancelled.");
      } else {
        setError("An error occurred during sign in. Please try again.");
      }
    }
  };

  useEffect(() => {
    if (user && !error && Object.keys(user).length > 0) {
      navigate("/");
    }
  }, [user, error, navigate]);

  return (
    <div className="min-h-screen bg-base-200 flex items-center justify-center overflow-hidden relative">
      {/* Mosaic grid background */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="grid grid-cols-4 sm:grid-cols-6 md:grid-cols-10 lg:grid-cols-12 gap-px bg-base-content/5">
          {shuffledNames.map((name, i) => (
            <div
              key={name.uniqueId || i}
              className="mosaic-tile bg-base-100 p-2 flex items-center justify-center min-h-[60px]"
              style={{
                animationDelay: `${i * 15}ms`,
              }}
            >
              <div className="text-center">
                <span className="font-[Oswald] font-semibold uppercase tracking-tight text-xs text-base-content/70 block truncate max-w-[80px]">
                  {name.name}
                </span>
                {name.grade && (
                  <span className={`text-[9px] font-bold ${gradeColors[name.grade] || 'text-base-content/40'}`}>
                    {name.grade}
                  </span>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Center box - responsive like home page */}
      <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 bg-base-100 border border-base-content/10 rounded-lg pointer-events-none
        w-[90vw] h-[85vh] max-w-[500px] max-h-[400px]
        md:w-[480px] md:h-[380px]"
      />

      {/* Main content */}
      <div className="relative z-10 flex flex-col items-center p-6">
        <img src="/logo.svg" alt="Monika Logo" className="logo w-52 md:w-64" />
        <h3 className="title mt-2">A moniker delivery system.</h3>

        {error && (
          <div className="mt-6 p-3 bg-error/10 border border-error/20 rounded-lg text-error text-sm max-w-xs text-center">
            {error}
          </div>
        )}

        <button
          type="button"
          onClick={handleGoogleSignIn}
          className="mt-8 group flex flex-col items-center gap-2"
        >
          <div className="w-14 h-14 rounded-full bg-primary flex items-center justify-center transition-all group-hover:ring-4 group-hover:ring-primary/20">
            <svg className="w-6 h-6 text-primary-content" viewBox="0 0 24 24" fill="currentColor">
              <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
              <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
              <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
              <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
            </svg>
          </div>
          <span className="text-[10px] uppercase tracking-wider text-base-content/50 group-hover:text-base-content transition-colors">
            Sign In
          </span>
        </button>
      </div>

      {/* Fade in animation */}
      <style>{`
        @keyframes mosaic-fade-in {
          from { opacity: 0; transform: scale(0.95); }
          to { opacity: var(--final-opacity); transform: scale(1); }
        }
        .mosaic-tile {
          animation: mosaic-fade-in 0.4s ease-out forwards;
          opacity: 0;
        }
      `}</style>
    </div>
  );
};

export default Signin;
